import Analytics from '../../../../../../../../analytics';

export const faOnPackageCardClick = ({ packageIndex, activeTabIndex, packageId }) => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_value: `CardClick|package_${packageIndex}_collection_${activeTabIndex}_${packageId}`,
  });
};

export const faOnPageExit = () => {
  const data = {};
  const productsViewed = JSON.parse(window.localStorage.getItem('storedPackages'));
  const sectionsViewed = JSON.parse(window.localStorage.getItem('storedSections'));
  data.product_list = productsViewed;
  data.content_details = sectionsViewed;
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.LIFE_CYCLE,
    event_name: Analytics.EVENT_NAMES.PAGE_EXIT,
    event_value: 'components_seen',
    components: data,
  });
};

export const faOnPackageVariantClick = ({
  variantType,
  variantIndex,
  packageIndex,
  activeTabIndex,
  packageId,
  variantCount,
}) => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_value: `CardClick|package_${packageIndex}_collection_${activeTabIndex}_${packageId}|Variant_${variantType}_${variantCount}_pos_${variantIndex}`,
  });
};

export const faOnVariantTrack = ({ packageIndex, activeTabIndex, packageId }) => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.SYSTEM_GENERATED,
    event_name: Analytics.EVENT_NAMES.CONTENT_VIEWED,
    event_value: `CardClick|package_${packageIndex}_collection_${activeTabIndex}_${packageId}|Variant_Selection`,
  });
};
